// src/components/FullNavbar.js
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../css/new.css';
import logo from '../images/logo.png';
import ThemeToggle from './ThemeToggle';

function FullNavbar() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  // Close navbar when route changes
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  // Function to check if a path is active
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top" expanded={expanded} onToggle={setExpanded}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand">
          <img src={logo} alt="Agency Bazar" />
          {/* <span>Agency Bazaar</span> */}
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={handleToggle}
        />

        <Navbar.Collapse id="navbar-nav" className="navigate">
          <Nav className="me-auto">
            {/* Home */}
            <Nav.Link 
              as={Link} 
              to="/" 
              className={isActive('/') ? 'active' : ''}
            >
              Home
            </Nav.Link>

            {/* About */}
            <Nav.Link 
              as={Link} 
              to="/about" 
              className={isActive('/about') ? 'active' : ''}
            >
              About
            </Nav.Link>

            {/* CAREERS DROPDOWN */}
            <NavDropdown 
              title={<span className={isActive('/Life') || isActive('/General') || isActive('/Health') || isActive('/Pos') || isActive('/Apply') ? 'active-dropdown' : ''}>Careers</span>} 
              id="careers-dropdown"
            >
              <NavDropdown.Item as={Link} to="/Life">
                Life Insurance Advisor
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/General">
                General Insurance Advisor
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Health">
                Health Insurance Advisor
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Pos">
                POS
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Apply">
                Apply Now
              </NavDropdown.Item>
            </NavDropdown>

            {/* PARTNERS DROPDOWN */}
            <NavDropdown 
              title={<span className={isActive('/partners') ? 'active-dropdown' : ''}>Partners</span>} 
              id="partners-dropdown"
            >
              <NavDropdown.Item as={Link} to="/partners/star-health">
                Star Health Insurance
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/partners/care-health">
                Care Health Insurance
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/partners/niva-bupa">
                Niva Bupa Health Insurance
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/partners/tata-aig">
                Tata AIG General Insurance
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/partners/aditya-birla">
                Aditya Birla Health Insurance
              </NavDropdown.Item>
            </NavDropdown>

            {/* HIGHLIGHTED LOGIN BUTTON */}
            <Nav.Link
              as={Link}
              to="/login"
              className={`login-highlight ${isActive('/login') ? 'active' : ''}`}
            >
              Admin Login
            </Nav.Link>
          </Nav>
          
          {/* Theme Toggle */}
          <div className="theme-toggle-wrapper">
            <ThemeToggle />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;


